<template>
  <Modal :title="lc.title" v-model="visible" maxWidth="360" controlsDirection="left">
    <template #activator="{ on, attrs }">
      <Button
        color="shade-white"
        :disabled="actionsDisabled"
        v-bind="attrs"
        v-on="on"
      >
        <Icon
          small
          color="primary"
          icon="$objects-trash-outline"
          ref="trashIcon"
        />
      </Button>
    </template>
    <span class="text-paragraph-2" v-text="lc.questionModal" />
    <template #append>
        <Button
          color="primary"
          text
          :label="lc.cancelLabel"
          :disabled="actionsDisabled"
          @click="closeModal"
        />
        <Button
          color="primary"
          :label="lc.deleteLabel"
          :disabled="actionsDisabled"
          @click="deleteFavicon"
        />
    </template>
</Modal>
</template>

<script>
import { Button, Modal, Icon, useLocale, useVueRouter, useNotification } from '@locaweb/design-system-vue'
import { NOTIFICATION_DEFAULTS } from '@/consts'
import useRemoveFavicon from '@/composables/api/useRemoveFavicon'
import { computed, ref, unref } from 'vue'

export default {
  name: 'ModalDeleteFavicon',
  components:
    {
      Button,
      Modal,
      Icon
    },
  emits: ['success'],
  setup (_, { emit }) {
    const { execute: executeFetch } = useRemoveFavicon()
    const notify = useNotification()
    const visible = ref(false)
    const actionsDisabled = ref(false)
    const lc = useLocale('site.favicon.faviconCard.modalDeleteFavicon')
    const { $route } = useVueRouter()
    const siteId = computed(() => $route.params.siteId)

    function closeModal () {
      visible.value = false
    }

    function onSuccess () {
      notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.successNotification, state: 'success' })
      emit('onSuccess')
      return closeModal()
    }

    function onError () {
      notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.failedNotification, state: 'error' })
      return closeModal()
    }

    const deleteFavicon = async () => {
      actionsDisabled.value = true
      await executeFetch({
        id: unref(siteId),
        onSuccess,
        onError
      })
      actionsDisabled.value = false
    }

    return {
      lc,
      visible,
      deleteFavicon,
      actionsDisabled,
      closeModal
    }
  }
}
</script>
